module.exports = __webpack_public_path__ + "static/media/people_commerce.c479f670.jpg";